import { MapActionTypes } from "../actionTypes/map"

export type MapReducer = {
  openPopups: {[id: string]: { dataIds: string[] }}
}
export const initialMapReducer: MapReducer = {
  openPopups: {}
}

export function map_state(state: MapReducer = initialMapReducer, action: MapActionTypes): MapReducer {

  switch (action.type) {
    case 'OPENED_MAP_POPUP':
      return {
        ...state,
        openPopups: {
          [action.id]: {
            dataIds: action.dataIds
          }
        }
      }
      
    case 'CLOSED_MAP_POPUP':
      let updatedPopups = {}
      Object.keys(state.openPopups).forEach((id) => {
        if (id !== action.id) 
          updatedPopups[id] = state.openPopups[id]
      })

      return {
        ...state,
        openPopups: updatedPopups
      }
      
    case 'CLOSE_ALL_MAP_POPUPS':
      return {
        ...state,
        openPopups: {}
      }
      
    default:
      return state
  }
}